

import { useEffect, useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"
import Swal from "sweetalert2"
import {
  getFollowUpReminderListAction,
  updateFollowUpReminderAction,
} from "../../../../../store/actions/FollowUpReminderAction"
import { formatDate } from "../../../../../utils/dateUtils"
const ServiceCallerFollowupReminder = () => {
  const dispatch = useDispatch()

  // Add default values to prevent undefined errors
  const {
    data: followupList = [],
    loading = false,
    error = null,
    updating = false,
    updateError = null,
  } = useSelector((state) => state.followUpReminder || {})


  const fetchReminders = useCallback(() => {
    dispatch(getFollowUpReminderListAction())
  }, [dispatch])

  useEffect(() => {
    fetchReminders()
  }, [])

  
  const handleStatusUpdate = async (reminderId, status, statusText) => {
    // Prevent multiple clicks
    if (updating) return

    const result = await Swal.fire({
      title: `Mark as ${statusText}?`,
      text: `This follow-up will be marked as ${statusText.toLowerCase()}.`,
      icon: status === "CANCELLED" ? "warning" : "question",
      showCancelButton: true,
      confirmButtonColor: status === "CANCELLED" ? "#d33" : "#28a745",
      cancelButtonColor: "#6c757d",
      confirmButtonText: `Yes, mark as ${statusText.toLowerCase()}`,
    })

    if (result.isConfirmed) {
      try {
        const response = await dispatch(updateFollowUpReminderAction(reminderId, status))
        if (response.success) {
          Swal.fire(`${statusText}!`, `The follow-up has been marked as ${statusText.toLowerCase()}.`, "success")
        } else {
          Swal.fire("Error!", response.error || "Failed to update reminder", "error")
        }
      } catch (error) {
        Swal.fire("Error!", "Something went wrong while updating the reminder", "error")
      }
    }
  }

  const handleMarkAsDone = (reminderId) => {
    handleStatusUpdate(reminderId, "DONE", "Done")
  }

  const handleCancel = (reminderId) => {
    handleStatusUpdate(reminderId, "CANCELLED", "Cancelled")
  }

  const getStatusBadge = (status) => {
    switch (status) {
      case "DONE":
        return <span className="badge bg-success">Done</span> 
      case "CANCELLED":
        return <span className="badge bg-danger">Cancelled</span>
      case "PENDING":
      default:
        return <span className="badge bg-warning">Pending</span>
    }
  }

  if (loading) {
    return (
      <div className="mt-3">
        <div className="text-center py-4">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
          <p className="mt-2">Loading follow-up reminders...</p>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="mt-3">
        <div className="alert alert-danger" role="alert">
          <strong>Error:</strong> {error}
          <br />
          <small>Check console for more details</small>
        </div>
      </div>
    )
  }

  return (
    <div className="mt-3">
      {followupList && followupList.length > 0 ? (
        followupList.map((item, index) => (
          <div
            key={item.reminder_id || index}
            className="mb-3 custom-timeline-panel timeline-panel bgl-dark border-0 p-3 rounded shadow-sm"
          >
            <h6 className="font-weight-bold mb-2">Follow-up Reminder #{item.reminder_id}</h6>
            <p className="mb-1">
              <strong>Follow-up Date:</strong> {formatDate(item.reminder_date)}
            </p>
            <p className="mb-1">
              <strong>Follow-up Time:</strong> {item.reminder_time}
            </p>
            <p className="mb-2">
              <strong>Status:</strong> {getStatusBadge(item.reminder_status)}
            </p>
            {
              item.reminder_status === "PENDING" && (
                <div className="d-flex gap-2">
                  <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => handleMarkAsDone(item.reminder_id)}
                    // disabled={updating || item.reminder_status === "DONE"}
                  >
                    {updating ? "Updating..." : "Mark as Done"}
                  </button>
                  <button
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => handleCancel(item.reminder_id)}
                    // disabled={updating || item.reminder_status === "CANCELLED"}
                  >
                    {updating ? "Updating..." : "Cancel"}
                  </button>
                </div>
              ) 
            }
            
          </div>
        ))
      ) : (
        <div className="text-muted text-center py-4">No follow-up reminders available</div>
      )}
    </div>
  )
}

export default ServiceCallerFollowupReminder
